import React from "react";
import { Route } from "react-router-dom";
import PrivateRoute from "src/routes/PrivateRoute";
import { InvalidContactsPage, SpamContactsPage } from "../pages";

export const routes = (
  <>
    <Route
      path="/group/spam"
      element={
        <PrivateRoute>
          <SpamContactsPage />
        </PrivateRoute>
      }
    />
    <Route
      path="/group/invalid-contacts"
      element={
        <PrivateRoute>
          <InvalidContactsPage />
        </PrivateRoute>
      }
    />
  </>
);
